/** 미션펀드 공식 메인 사이트 */
export const MISSIONFUND_HOME_URL = 'https://missionfund.org/';

/** 미션펀드 — 개인정보 처리방침 */
export const MISSIONFUND_PRIVACY_POLICY_URL =
  'https://my.missionfund.org/policy/';

/** 미션펀드 — 서비스 약관 및 운영 정책 */
export const MISSIONFUND_TERMS_OF_SERVICE_URL =
  'https://my.missionfund.org/terms/';

/** 미션펀드 공식 사이트 — 모금지원 상담 */
export const MISSIONFUND_SUPPORT_URL = 'https://missionfund.org/support/';
